const formData = {
  shared: {
    path: 'Home >',
  },
  tabs: [
    // {
    //   key: 1,
    //   title: 'All Videos',
    //   route: '/dashboard/videos',
    // },
    // {
    //   key: 2,
    //   title: 'Flagged Videos',
    //   route: '/dashboard/flagged',
    // },
    {
      key: 1,
      title: 'App Users',
      route: '/dashboard/app',
    },
    {
      key: 2,
      title: 'System Users',
      route: '/dashboard/system',
    },
    {
      key: 3,
      title: 'Products',
      route: '/dashboard/products',
    },
    {
      key: 4,
      title: 'Domains',
      route: '/dashboard/domains',
    },
    {
      key: 5,
      title: 'Orders',
      route: '/dashboard/orders',
    },
    {
      key: 6,
      title: 'App Content',
      route: '/dashboard/content',
    },
    // {
    //   key: 4,
    //   title: 'Subscriptions',
    //   route: '/dashboard/subscriptions',
    // },
  ],
}
const getFormData = (key, value) =>
  formData.tabs.find((t) => t.key === key)[value]

export { formData, getFormData }
